<!-- Free Form Style Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.line_style">
      </h4>
      <!-- Line Color -->
      <medsurf-design-form-control-input-color-picker [control]="freeFormStyleForm.controls.strokeColor"
        [class]="'w-full'"
        [label]="'global.stroke_color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Line Width -->
      <medsurf-design-form-control-input-number [control]="freeFormStyleForm.controls.strokeWidth"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
        [label]="'global.stroke_width'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <!-- Line Dash -->
      <medsurf-design-form-control-input-dropdown [control]="freeFormStyleForm.controls.dash"
        [class]="'w-full'"
        [options]="FlatModels.FreeFormStyleEntityModels.DashArray"
        [label]="'global.stroke_dash'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
    </div>
  </medsurf-design-form-control-form>
}